import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import OnlineBookingModal from '../../app/modules/online-booking/modals/OnlineBookingModals';

import TicketModal from '../../app/modules/tickets/modals/TicketModal';
import UserModal from '../../app/modules/users/modals/UserModal';
import { GlobalRenewalReminder } from '../../app/modules/payments/zatca-integration/GlobalRenewalReminder';
import { MenuComponent } from '../assets/ts/components';
import { AsideDefault } from './components/aside/AsideDefault';
import { Content } from './components/Content';
import { HeaderWrapper } from './components/header/HeaderWrapper';
import { ScrollTop } from './components/ScrollTop';
import { PageDataProvider } from './core';

const MasterLayout: React.FC = ({ children }) => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>

            <div className='post d-flex flex-column-fluid' id='kt_post'>
              {/* <Toolbar /> */}
              <Content>{children}</Content>
            </div>
          </div>
        </div>
      </div>
      {/* begin:: Modals */}
      <TicketModal />
      <UserModal />
      <OnlineBookingModal />
      <GlobalRenewalReminder />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export { MasterLayout }
